export interface IMedicationQuantityInitialValues {
    quantity: string;
    daysSupply: number;
}

export interface IMedicationQuantity {
    quantity?: number;
    daysSupply?: number;
}

export const medicationQuantityInitialValues: IMedicationQuantityInitialValues = {
    quantity: '30',
    daysSupply: 30,
};

export const medicationDaysSupplyOptions = [
    { label: 'Daily', value: 1 },
    { label: 'Monthly', value: 30 },
];

export const medicationOptionalDaysSupplyOptions = [
    ...medicationDaysSupplyOptions,
    { label: 'Unsure at this time', value: 0 },
];